import { getIconImage } from '../../../draw-images';
import { SIZES } from '../constants';
import { NotificationIcon } from '../types';

/**
 * Рисует массив иконок.
 * @returns ширина отрисованной области
 */
export function drawIcons(ctx: CanvasRenderingContext2D, x: number, y: number, icons: NotificationIcon[]): number {
    let currentX = x;

    for (let i = 0; i < icons.length; i++) {
        const icon = icons[i];
        const img = getIconImage({
            name: icon.name,
            iconColor: icon.color,
        });

        // Добавляем gap перед иконкой (кроме первой)
        if (i > 0) {
            currentX += SIZES.iconGap;
        }

        if (img) {
            // y - SIZES.icon / 2 для центрирования по вертикали
            ctx.drawImage(img, currentX, y - SIZES.icon / 2, SIZES.icon, SIZES.icon);
        }
        // Всегда резервируем место для иконки (для консистентности с layout-calculator)
        currentX += SIZES.icon;
    }

    return currentX - x;
}
